import styled from '@emotion/styled';
import { useTranslation } from 'next-i18next';
import { useDirectMessageNavigation } from 'src/components/DirectMessage/context';
import { EVENT_NAME, EVENT_TYPE } from 'src/types/Event';
import { pushEvent } from 'src/utils/event-gateway';
import FollowingList from './FollowList';
import RoomListSection from './RoomList';
import FollowLinkItem from './RoomList/FollowLink';
import SectionTitle from './SectionTitle';
const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({
  theme
}) => theme.color.bg1};
`;
const FollowSection = styled(FollowingList)`
  width: 100%;
  ${({
  theme
}) => theme.screenSize.tablet} {
    padding: 0 16px;
  }
`;
const Title = styled.h1`
  margin: 0;
  padding: 16px 24px 12px 24px;

  font-size: 30px;
  font-weight: 700;

  color: ${({
  theme
}) => theme.color.contentDeep};

  ${({
  theme
}) => theme.screenSize.mobile} {
    padding: 16px;
  }
`;
const StyledFollowLinkItem = styled(FollowLinkItem)`
  padding: 12px 24px;

  ${({
  theme
}) => theme.screenSize.mobile} {
    padding: 12px 16px;
  }
  ::after {
    content: '';
    position: absolute;
    bottom: calc(-1 * (4px + 1px));
    left: 0;
    width: 100%;
    height: 1px;
    background-color: ${({
  theme
}) => theme.color.surface2};
  }
`;
interface Props {
  className?: string;
}
const DirectMessageLobby = ({
  className
}: Props) => {
  const {
    t
  } = useTranslation();
  const {
    openFollowing
  } = useDirectMessageNavigation();
  const handleOpenFollowTab = () => {
    pushEvent({
      eventType: EVENT_TYPE.LOG,
      eventName: EVENT_NAME.MESSAGE__OPEN_FOLLOW,
      eventParams: {
        action_category: 'open',
        tab: 'message',
        page: 'following',
        target: 'follow',
        referrer: 'follow_title'
      }
    });
    openFollowing();
  };
  return <Container className={className} data-sentry-element="Container" data-sentry-component="DirectMessageLobby" data-sentry-source-file="index.tsx">
      <Title data-sentry-element="Title" data-sentry-source-file="index.tsx">{t('message_title')}</Title>
      <SectionTitle onClick={handleOpenFollowTab} data-sentry-element="SectionTitle" data-sentry-source-file="index.tsx">{t('message_subtitle_follow')}</SectionTitle>
      <FollowSection data-sentry-element="FollowSection" data-sentry-source-file="index.tsx" />
      <SectionTitle data-sentry-element="SectionTitle" data-sentry-source-file="index.tsx">{t('message_subtitle_messages')}</SectionTitle>
      <RoomListSection data-sentry-element="RoomListSection" data-sentry-source-file="index.tsx">
        <StyledFollowLinkItem data-sentry-element="StyledFollowLinkItem" data-sentry-source-file="index.tsx" />
      </RoomListSection>
    </Container>;
};
export default DirectMessageLobby;